import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { WillConditionScreen } from "../components/WillConditionScreen";
import { WillConditionWarningScreen } from "../components/WillConditionWarningScreen";
import { WillCopyInfoScreen } from "../components/WillCopyInfoScreen";
import { WillSafeDepositScreen } from "../components/WillSafeDepositScreen";

export function createCheckWillScreens(): FlowScreenConfig[] {
  return [
    {
      id: "will_location",
      layout: "full",
      title: "Do you have the original will?",
      subtitle:
        "Look for wet-ink signatures you can feel, usually in blue or black ink. Printed or flat signatures indicate a copy.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "original_in_hand", label: "Yes, it's the original" },
          { value: "copy_only", label: "I only have a copy" },
          { value: "safe_deposit_box", label: "No, it's located in a safety deposit box" },
        ],
      },
    },
    {
      id: "will_condition_issues",
      layout: "full",
      customComponent: WillConditionScreen,
      shouldDisplay: ({ answers }) => answers["will_location"] === "original_in_hand",
      validate: (answers): Record<string, string> => {
        const issues = answers["will_condition_issues"];
        if (!issues || !Array.isArray(issues) || issues.length === 0) {
          return { will_condition_issues: "Select at least one option" };
        }
        return {};
      },
    },
    {
      id: "will_condition_warning",
      layout: "full",
      customComponent: WillConditionWarningScreen,
      getButtonText: () => "Continue with copy",
      shouldDisplay: ({ answers }) => {
        if (answers["will_location"] !== "original_in_hand") return false;
        const issues = answers["will_condition_issues"];
        if (!Array.isArray(issues) || issues.length === 0) return false;
        return !issues.includes("none");
      },
    },
    {
      id: "will_copy_info",
      layout: "full",
      customComponent: WillCopyInfoScreen,
      getButtonText: () => "Continue with copy",
      shouldDisplay: ({ answers }) => answers["will_location"] === "copy_only",
    },
    {
      id: "will_safe_deposit_redirect",
      layout: "full",
      customComponent: WillSafeDepositScreen,
      shouldDisplay: ({ answers }) => answers["will_location"] === "safe_deposit_box",
    },
  ];
}
